import React, { Component } from "react";
import { Button, Columns, Field } from "components/elements";
import GetUserInfoFromCode from "../../calls/getUserByCode.js";
import {
  CLOUDINARY_API_KEY,
  CLOUDINARY_NAME,
} from "../../../../constants/images/cloudinary";
import {
  USER_SMALL_PARAMS,
  userPhotoID
} from "../../../../constants/images/sizesAndQuality";
import { Subscribe } from "unstated";
import AppContainer from "../../../context/AppContainer.js";
import cloudinary from "cloudinary-core";
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY
});
class InlineReferral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInput: false,
      refCode: "",
      error: false,
      requiredError: null
    };
  }

  showRefInput = () => {
    this.setState({ showInput: true });
  };

  hideRefInput = () => {
    this.setState({ showInput: false });
  };

  handleCodeChange = value => {
    this.setState({
      refCode: value,
      error: false
    });

    //this.props.onChange()
  };

  handleRefApply = getCodeInfo => {
    if (!this.state.refCode) {
      this.setState({
        error: true,
        requiredError: "Please enter a referral code."
      });
      return false;
    }

    this.setState({ error: false, requiredError: false });

    getCodeInfo(
      this.state.refCode,
      this.handleSuccess,
      this.handleFailure,
      this.handleLoading,
      'manual-micro'
    );
  };

  handleSuccess = () => {
    this.props.onSuccessCode(this.state.refCode);
  };
  handleFailure = () => {
    this.props.onFailureCode(null);
  };
  handleLoading = () => {
    this.props.onLoading();
  };

  render() {
    const { showInput, error, requiredError, refCode } = this.state;
    const { callDescription, size, showLabel, shortDescription } = this.props;
    return (
      //This section is the header
      <GetUserInfoFromCode
        referralDescription={callDescription}
        shortDescription={shortDescription}
        entryType={'manual'}
        fireOnMount={false}
        render={({
          userLoading,
          getUserInfo,
          userError,
          hasUserData,
          userData
        }) => {
          let showError = userError || error ? true : false;


          return (
            <div className="referrals-inline-wrapper">
              <Subscribe to={[AppContainer]}>
                {(
                  auth //went ahead and included the search parameter here in case we need acccess to it down the road.
                ) => {
                  return (
                    <>
                      {showInput && (
                        <div>
                          {hasUserData && (
                            <Columns className="is-mobile">
                              <Columns.Column size={2}>
                                <img
                                  src={cl.url(
                                    userPhotoID(userData.senderProfilePhoto),
                                    USER_SMALL_PARAMS
                                  )}
                                  className="is-rounded"
                                  alt={
                                    "Referral from " + userData.senderFirstName
                                  }
                                />
                              </Columns.Column>
                              <Columns.Column
                                size={10}
                                className="referral-micro-avatar-text"
                              >
                                {userData.senderFirstName} is going to hook you
                                up!
                                <br />
                                When you rent or list your first motorcycle
                                you'll get something sweet.
                              </Columns.Column>
                            </Columns>
                          )}

                          {!hasUserData && (
                            <div style={{ maxWidth: "225px" }}>
                              {showLabel && <label className="label is-size-7">Referral Code</label>}
                              <Field
                                size={size}
                                placeholder="Enter Code"
                                onChange={({ value }) =>
                                  this.handleCodeChange(value)
                                }
                                onBlur={() => this.handleRefApply(getUserInfo)}
                                type="input"
                                disabled={userLoading}
                                showErrors={false}
                                value={refCode}
                                isRounded
                                id="micro-input"
                                name="micro-input"
                                hasAddOns={true}
                                rightAddOn={
                                  <Button
                                    color="primary"
                                    type="button"
                                    className="has-text-weight-bold is-uppercase"
                                    size={size}
                                    loading={userLoading}
                                    disabled={userLoading}
                                    onClick={() =>
                                      this.handleRefApply(getUserInfo)
                                    }
                                  >
                                    Redeem
                                  </Button>
                                }
                              />
                            </div>
                          )}

                          {showError && ( //could probably combine this required check into the call? eh...nah.
                            <div className="is-size-7 has-text-danger">
                              {requiredError && (
                                <span>Please enter a referral code.</span>
                              )}
                              {userError && <span>{userError}</span>}
                            </div>
                          )}
                        </div>
                      )}

                      {!showInput && (
                        <button
                          className="has-text-primary has-text-weight-bold button is-text"
                          type="button"
                          style={{ textDecoration: "none" }}
                          onClick={() => this.showRefInput()}
                        >
                          I have a referral code!
                        </button>
                      )}
                    </>
                  )
                }}
              </Subscribe>
            </div>
          );
        }}
      />
    );
  }
}

export default InlineReferral;

InlineReferral.defaultProps = {
  callDescription: "Process or Get Referral Info",
  shortDescription: "missing",
  size: "small",
  showLabel: true,
  onChange: function () { },
  onSuccessCode: function () { },
  onFailureCode: function () { },
  onLoading: function () { }
};
